module.exports = "<div class=\"form-group\">\r\n\r\n  <div style=\"opacity: 0; height: 60px;\">\r\n  </div>\r\n</div>"